import { EnhancedHeader } from '@/components/EnhancedHeader';
import { PredictionAccuracyDashboard } from '@/components/PredictionAccuracyDashboard';

export default function PredictionDashboard() {
  return (
    <div className="min-h-screen bg-gradient-dark">
      <EnhancedHeader />
      
      <main className="container mx-auto px-4 py-8">
        <h1 className="sr-only">Prediction Accuracy Dashboard</h1>
        <PredictionAccuracyDashboard />
      </main>
    </div>
  );
}
